// extracted by mini-css-extract-plugin
module.exports = {"generalInformation":"GeneralInformation_generalInformation__1C71Z","title":"GeneralInformation_title__3f4RQ"};